const runtimeConfig = window.__APP_CONFIG__ || {};

const normalizeUrl = (value?: string) => (value || "").replace(/\/$/, "");

export const API_BASE_URL = normalizeUrl(
  runtimeConfig.API_URL || import.meta.env.VITE_API_URL || "",
);
export const OPENAI_BASE_URL = normalizeUrl(
  runtimeConfig.OPENAI_BASE_URL ||
    import.meta.env.VITE_OPENAI_BASE_URL ||
    `${API_BASE_URL}/v1`,
);
export const PLATFORM_FRONTEND_URL = normalizeUrl(
  runtimeConfig.PLATFORM_URL || import.meta.env.VITE_PLATFORM_URL || API_BASE_URL,
);
export const PLATFORM_LOGIN_URL = `${PLATFORM_FRONTEND_URL}/login?redirect=chat`;

export const resolvePlatformFrontendUrl = (url?: string) => {
  if (!url) return PLATFORM_FRONTEND_URL;

  try {
    if (/^https?:\/\//i.test(url)) {
      return normalizeUrl(url);
    }

    const baseUrl = new URL(PLATFORM_FRONTEND_URL || window.location.origin);
    const resolvedUrl = new URL(url, baseUrl.href);
    return `${baseUrl.origin}${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}`;
  } catch {
    return PLATFORM_FRONTEND_URL;
  }
};
